<h2 mat-dialog-title>Select Asset to Upload</h2>
<mat-dialog-content>
  <input type="file" (change)="onFileSelected($event)" [attr.multiple]="data.allowMultiple ? '' : null" />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="accent" type="button" (click)="upload()" [disabled]="!selectedFile">Upload</button>
</mat-dialog-actions>